export default __webpack_public_path__ + "static/media/tuyendung.725759c2.jpg";